import { render, staticRenderFns } from "./OrderInvoice.vue?vue&type=template&id=2e51acc3&scoped=true&"
import script from "./OrderInvoice.vue?vue&type=script&lang=ts&"
export * from "./OrderInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./OrderInvoice.vue?vue&type=style&index=0&id=2e51acc3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e51acc3",
  null
  
)

export default component.exports